import React from 'react';
import './Services.css';

const Services = () => {
  const services = [
    {
      icon: '🌐',
      title: 'Website Building',
      description: 'Professional websites built with modern technologies and responsive design.'
    },
    {
      icon: '🤖',
      title: 'AI Automation Project',
      description: 'Intelligent automation solutions powered by AI to streamline your business processes.'
    },
    {
      icon: '📱',
      title: 'App Development',
      description: 'Native and cross-platform mobile applications for iOS and Android devices.'
    },
    {
      icon: '🎨',
      title: 'Logo Designing',
      description: 'Creative and professional logo designs that represent your brand identity.'
    },
    {
      icon: '☁️',
      title: 'Cloud Solutions',
      description: 'Scalable cloud infrastructure and migration services for your business needs.'
    },
    {
      icon: '📡',
      title: 'Internet of Things (IoT)',
      description: 'Connected devices and smart automation solutions for homes and industry.'
    },
    {
      icon: '⚙️',
      title: 'Custom Development',
      description: 'Tailored software solutions designed to meet your specific business requirements.'
    },
    {
      icon: '💻',
      title: 'Refurbished Laptops Sales',
      description: 'Quality refurbished laptops at affordable prices with warranty and support.'
    }
  ];

  return (
    <section id="services" className="services">
      <div className="container">
        <div className="section-header">
          <h2 className="section-title">Our Services</h2>
          <p className="section-subtitle">What We Offer</p>
        </div>
        <div className="services-grid">
          {services.map((service, index) => (
            <div key={index} className="service-card">
              <div className="service-icon">{service.icon}</div>
              <h3 className="service-title">{service.title}</h3>
              <p className="service-description">{service.description}</p>
              <div className="service-hover-effect"></div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Services;

